import { FC } from 'react';

import HelpIcon from '@z-components/static/images/help-icon-black.svg';
import styles from './EmptyModule.module.scss';

const TRANSLATIONS = {
  en: {
    emptyText: 'There is no ',
    emptyTextSubstring: ' yet',
  },
  ja: {
    emptyText: 'まだ',
    emptyTextSubstring: 'がありません',
  },
};

interface Props {
  language?: 'en' | 'ja';
  text: string;
}

const EmptyModule: FC<Props> = ({ language = 'ja', text }) => (
  <div className={styles.empty}>
    <HelpIcon />
    <p className={styles.text}>
      {TRANSLATIONS[language].emptyText}
      {text}
      {TRANSLATIONS[language].emptyTextSubstring}
    </p>
  </div>
);

export default EmptyModule;
export type { Props as EmptyModuleProps };
